import { LayoutService } from '@/layout/service/layout.service';
import { IpService } from '@/shared/services/ip/ip.service';
import { StorageService } from '@/shared/services/storage/storage.service';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `<router-outlet></router-outlet>`
})
export class AppComponent implements OnInit {

    private layoutService = inject(LayoutService);
    private ipService = inject(IpService);
    private storageService = inject(StorageService);

    ngOnInit() {
        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: true,
            menuMode: 'static',
        }));
        if (!this.storageService.existsCookie()) {
            this.storageService.setCookie();
        }
        this.ipService.getIp().subscribe({
            next: (data) => {
                this.storageService.setIp(data['ip']);
            }
        })
    }

}
